import { getAppBridge } from './utils.js';

const getLoanField = (name) => document.getElementById(name);

class Loan extends ice.ScriptingObject {
  constructor() {
    super('Loan');
    this.loanId = 'ABC123';
    this.onSaved = new ice.Event({
      name: 'onSaved',
      objectId: this.constructor.name,
    });
    this.onPreSave = new ice.Event({
      name: 'onPreSave',
      objectId: this.constructor.name,
    });
    this.onLoanAmountChanged = new ice.Event({
      name: 'onLoanAmountChanged',
      objectId: this.constructor.name,
    });
    this.onLoanTermChanged = new ice.Event({
      name: 'onLoanTermChanged',
      objectId: this.constructor.name,
    });
    this.onDownPaymentChanged = new ice.Event({
      name: 'onDownPaymentChanged',
      objectId: this.constructor.name,
    });

    getLoanField('amount').addEventListener('blur', async (e) => {
      const appBridge = await getAppBridge();
      appBridge.dispatchEvent({
        event: this.onLoanAmountChanged,
        eventParams: {
          amount: e.target.value,
        },
      });
    });

    getLoanField('term').addEventListener('blur', async (e) => {
      const appBridge = await getAppBridge();
      appBridge.dispatchEvent({
        event: this.onLoanTermChanged,
        eventParams: { term: e.target.value },
      });
    });

    getLoanField('downPayment').addEventListener('blur', async (e) => {
      const appBridge = await getAppBridge();
      appBridge.dispatchEvent({
        event: this.onDownPaymentChanged,
        eventParams: {
          downPayment: e.target.value,
        },
      });
    });
  }

  getLoanDetails = () => ({
    id: this.loanId,
    firstName: getLoanField('firstName').value,
    lastName: getLoanField('lastName').value,
    ssn: getLoanField('ssn').value,
    amount: getLoanField('amount').value,
    term: getLoanField('term').value,
    downPayment: getLoanField('downPayment').value,
    creditScore: getLoanField('creditScore').value,
  });

  setCreditScore = (creditScore) => {
    const creditScoreElement = document.getElementById('creditScore');
    if (creditScoreElement) creditScoreElement.value = creditScore;
  };

  saveLoan = async () => {
    const appBridge = await getAppBridge();
    appBridge.dispatchEvent({
      event: this.onSaved,
      eventParams: { id: this.loanId },
    });
  };
}

export { Loan };
